import Vue from "vue";
import VueRouter from "vue-router";

import AttendanceReport from "./modules/report/modules/AttendanceReport";
import AttendanceDetailReport from "./modules/report/modules/AttendanceDetailReport";
import AttendanceOverview from "./modules/report/modules/AttendanceOverview";
import AttendanceUpdateReport from "./modules/report/modules/AttendanceUpdateReport";
import MemberAgeReport from "./modules/report/modules/MemberAgeReport";
import MetricsReport from "./modules/report/modules/MetricsReport";
import GroupRoleReport from "./modules/report/modules/GroupRoleReport";
import GroupStatisticReport from "./modules/report/modules/GroupStatisticReport";
import Dashboard from "./modules/dashboard/Dashboard";
import EventFormGraduation from "./modules/event-form/EventFormGraduation";
import EventFormSessionList from "./modules/event-form-session/EventFormSessionList";
import GatheringCreate from "./modules/gathering/GatheringCreate";
import GatheringEdit from "./modules/gathering/GatheringEdit";
import GatheringList from "./modules/gathering/GatheringList";
import GatheringView from "./modules/gathering/GatheringView";
import GroupCreate from "./modules/group/GroupCreate";
import GroupEdit from "./modules/group/GroupEdit";
import GroupList from "./modules/group/GroupList";
import GroupView from "./modules/group/GroupView";
import GroupCategoryCreate from "./modules/group-category/GroupCategoryCreate";
import GroupCategoryEdit from "./modules/group-category/GroupCategoryEdit";
import GroupCategoryList from "./modules/group-category/GroupCategoryList";
import GroupCategoryView from "./modules/group-category/GroupCategoryView";
import GroupRoleCreate from "./modules/group-role/GroupRoleCreate";
import GroupRoleEdit from "./modules/group-role/GroupRoleEdit";
import GroupRoleList from "./modules/group-role/GroupRoleList";
import GroupRoleView from "./modules/group-role/GroupRoleView";
import GroupStatisticTemplateCreate from "./modules/group-statistic-template/GroupStatisticTemplateCreate";
import GroupStatisticTemplateEdit from "./modules/group-statistic-template/GroupStatisticTemplateEdit";
import GroupStatisticTemplateList from "./modules/group-statistic-template/GroupStatisticTemplateList";
import GroupStatisticTemplateView from "./modules/group-statistic-template/GroupStatisticTemplateView";
import MemberBulkUpdate from "./modules/member/MemberBulkUpdate";
import MemberCreate from "./modules/member/MemberCreate";
import MemberDuplicateList from "./modules/member/MemberDuplicateList";
import MemberEdit from "./modules/member/MemberEdit";
import MemberList from "./modules/member/MemberList";
import MemberMoveGroup from "./modules/member/MemberMoveGroup";
import MemberTrashedList from "./modules/member/MemberTrashedList";
import MemberView from "./modules/member/MemberView";
import MetricCreate from "./modules/metric/MetricCreate";
import MetricEdit from "./modules/metric/MetricEdit";
import MetricList from "./modules/metric/MetricList";
import MetricView from "./modules/metric/MetricView";
import MetricCategoryCreate from "./modules/metric-category/MetricCategoryCreate";
import MetricCategoryEdit from "./modules/metric-category/MetricCategoryEdit";
import MetricCategoryList from "./modules/metric-category/MetricCategoryList";
import MetricCategoryView from "./modules/metric-category/MetricCategoryView";
import MetricRecordCreate from "./modules/metric-record/MetricRecordCreate";
import MetricRecordEdit from "./modules/metric-record/MetricRecordEdit";
import MetricRecordList from "./modules/metric-record/MetricRecordList";
import MetricRecordView from "./modules/metric-record/MetricRecordView";
import Report from "./modules/report/Report";
import SettingForm from "./modules/setting/SettingForm";
import SmsCreate from "./modules/sms/SmsCreate";
import SmsEdit from "./modules/sms/SmsEdit";
import SmsList from "./modules/sms/SmsList";
import SmsView from "./modules/sms/SmsView";
import SmsObserverCreate from "./modules/sms-observer/SmsObserverCreate";
import SmsObserverEdit from "./modules/sms-observer/SmsObserverEdit";
import SmsObserverList from "./modules/sms-observer/SmsObserverList";
import SmsObserverView from "./modules/sms-observer/SmsObserverView";
import TranslationBillingEdit from "./modules/translation-billing/TranslationBillingEdit";
import TranslationBillingList from "./modules/translation-billing/TranslationBillingList";
import TranslationBillingView from "./modules/translation-billing/TranslationBillingView";
import TranslationDraftCreate from "./modules/translation-draft/TranslationDraftCreate";
import TranslationDraftEdit from "./modules/translation-draft/TranslationDraftEdit";
import TranslationDraftList from "./modules/translation-draft/TranslationDraftList";
import TranslationDraftView from "./modules/translation-draft/TranslationDraftView";
import TranslationUploadBatchCreate from "./modules/translation-upload-batch/TranslationUploadBatchCreate";
import TranslationUploadBatchList from "./modules/translation-upload-batch/TranslationUploadBatchList";
import TranslationUploadBatchView from "./modules/translation-upload-batch/TranslationUploadBatchView";
import TranslationUploadBatchEdit from "./modules/translation-upload-batch/TranslationUploadBatchEdit";
import UserRoleCreate from "./modules/user-role/UserRoleCreate";
import UserRoleEdit from "./modules/user-role/UserRoleEdit";
import UserRoleList from "./modules/user-role/UserRoleList";
import UserRoleView from "./modules/user-role/UserRoleView";
import ValidationRuleCreate from "./modules/validation-rule/ValidationRuleCreate";
import ValidationRuleEdit from "./modules/validation-rule/ValidationRuleEdit";
import ValidationRuleList from "./modules/validation-rule/ValidationRuleList";
import ValidationRuleView from "./modules/validation-rule/ValidationRuleView";
import VisitorBulkUpdate from "./modules/visitor/VisitorBulkUpdate";
import VisitorCreate from "./modules/visitor/VisitorCreate";
import VisitorDuplicateList from "./modules/visitor/VisitorDuplicateList";
import VisitorEdit from "./modules/visitor/VisitorEdit";
import VisitorList from "./modules/visitor/VisitorList";
import VisitorTrashedList from "./modules/visitor/VisitorTrashedList";
import VisitorView from "./modules/visitor/VisitorView";
import { hideOpenDropdowns, setPreviousUrl } from "./helpers";

Vue.use(VueRouter);

const pathPrefix = "/admin";

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: `${pathPrefix}`,
            component: Dashboard,
        },
        {
            path: `${pathPrefix}/dashboard`,
            component: Dashboard,
        },
        {
            path: `${pathPrefix}/event-forms/:id/graduations`,
            component: EventFormGraduation,
        },
        {
            path: `${pathPrefix}/event-forms/:id/sessions`,
            component: EventFormSessionList,
        },
        {
            path: `${pathPrefix}/gatherings`,
            component: GatheringList,
        },
        {
            path: `${pathPrefix}/gatherings/create`,
            component: GatheringCreate,
        },
        {
            path: `${pathPrefix}/gatherings/:id`,
            component: GatheringView,
        },
        {
            path: `${pathPrefix}/gatherings/:id/edit`,
            component: GatheringEdit,
        },
        {
            path: `${pathPrefix}/group-categories`,
            component: GroupCategoryList,
        },
        {
            path: `${pathPrefix}/group-categories/create`,
            component: GroupCategoryCreate,
        },
        {
            path: `${pathPrefix}/group-categories/:id`,
            component: GroupCategoryView,
        },
        {
            path: `${pathPrefix}/group-categories/:id/edit`,
            component: GroupCategoryEdit,
        },
        {
            path: `${pathPrefix}/group-roles`,
            component: GroupRoleList,
        },
        {
            path: `${pathPrefix}/group-roles/create`,
            component: GroupRoleCreate,
        },
        {
            path: `${pathPrefix}/group-roles/:id`,
            component: GroupRoleView,
        },
        {
            path: `${pathPrefix}/group-roles/:id/edit`,
            component: GroupRoleEdit,
        },
        {
            path: `${pathPrefix}/group-statistic-templates`,
            component: GroupStatisticTemplateList,
        },
        {
            path: `${pathPrefix}/group-statistic-templates/create`,
            component: GroupStatisticTemplateCreate,
        },
        {
            path: `${pathPrefix}/group-statistic-templates/:id`,
            component: GroupStatisticTemplateView,
        },
        {
            path: `${pathPrefix}/group-statistic-templates/:id/edit`,
            component: GroupStatisticTemplateEdit,
        },
        {
            path: `${pathPrefix}/groups`,
            component: GroupList,
        },
        {
            path: `${pathPrefix}/groups/create`,
            component: GroupCreate,
        },
        {
            path: `${pathPrefix}/groups/:id`,
            component: GroupView,
        },
        {
            path: `${pathPrefix}/groups/:id/edit`,
            component: GroupEdit,
        },
        {
            path: `${pathPrefix}/visitors`,
            component: VisitorList,
        },
        {
            path: `${pathPrefix}/visitors/trashed`,
            component: VisitorTrashedList,
        },
        {
            path: `${pathPrefix}/visitors/create`,
            component: VisitorCreate,
        },
        {
            path: `${pathPrefix}/visitors/duplicate`,
            component: VisitorDuplicateList,
        },
        {
            path: `${pathPrefix}/visitors/edit`,
            component: VisitorBulkUpdate,
        },
        {
            path: `${pathPrefix}/visitors/:id`,
            component: VisitorView,
        },
        {
            path: `${pathPrefix}/visitors/:id/edit`,
            component: VisitorEdit,
        },
        {
            path: `${pathPrefix}/members`,
            component: MemberList,
        },
        {
            path: `${pathPrefix}/members/trashed`,
            component: MemberTrashedList,
        },
        {
            path: `${pathPrefix}/members/create`,
            component: MemberCreate,
        },
        {
            path: `${pathPrefix}/members/duplicate`,
            component: MemberDuplicateList,
        },
        {
            path: `${pathPrefix}/members/edit`,
            component: MemberBulkUpdate,
        },
        {
            path: `${pathPrefix}/members/:id`,
            component: MemberView,
        },
        {
            path: `${pathPrefix}/members/:id/edit`,
            component: MemberEdit,
        },
        {
            path: `${pathPrefix}/members/:id/move-group`,
            component: MemberMoveGroup,
        },
        {
            path: `${pathPrefix}/metric-categories`,
            component: MetricCategoryList,
        },
        {
            path: `${pathPrefix}/metric-categories/create`,
            component: MetricCategoryCreate,
        },
        {
            path: `${pathPrefix}/metric-categories/:id`,
            component: MetricCategoryView,
        },
        {
            path: `${pathPrefix}/metric-categories/:id/edit`,
            component: MetricCategoryEdit,
        },
        {
            path: `${pathPrefix}/metric-records`,
            component: MetricRecordList,
        },
        {
            path: `${pathPrefix}/metric-records/create`,
            component: MetricRecordCreate,
        },
        {
            path: `${pathPrefix}/metric-records/:id`,
            component: MetricRecordView,
        },
        {
            path: `${pathPrefix}/metric-records/:id/edit`,
            component: MetricRecordEdit,
        },
        {
            path: `${pathPrefix}/metrics`,
            component: MetricList,
        },
        {
            path: `${pathPrefix}/metrics/create`,
            component: MetricCreate,
        },
        {
            path: `${pathPrefix}/metrics/:id`,
            component: MetricView,
        },
        {
            path: `${pathPrefix}/metrics/:id/edit`,
            component: MetricEdit,
        },
        {
            path: `${pathPrefix}/reports`,
            component: Report,
        },
        {
            path: `${pathPrefix}/reports/attendance-overview`,
            component: AttendanceOverview,
        },
        {
            path: `${pathPrefix}/reports/attendance-update`,
            component: AttendanceUpdateReport,
        },
        {
            path: `${pathPrefix}/reports/attendances`,
            component: AttendanceReport,
        },
        {
            path: `${pathPrefix}/reports/attendances/:id`,
            component: AttendanceDetailReport,
        },
        {
            path: `${pathPrefix}/reports/group-roles`,
            component: GroupRoleReport,
        },
        {
            path: `${pathPrefix}/reports/group-statistics`,
            component: GroupStatisticReport,
        },
        {
            path: `${pathPrefix}/reports/member-age`,
            component: MemberAgeReport,
        },
        {
            path: `${pathPrefix}/reports/metrics`,
            component: MetricsReport,
        },
        {
            path: `${pathPrefix}/settings`,
            component: SettingForm,
        },
        {
            path: `${pathPrefix}/sms`,
            component: SmsList,
        },
        {
            path: `${pathPrefix}/sms/create`,
            component: SmsCreate,
        },
        {
            path: `${pathPrefix}/sms/:id`,
            component: SmsView,
        },
        {
            path: `${pathPrefix}/sms/:id/edit`,
            component: SmsEdit,
        },
        {
            path: `${pathPrefix}/sms-observers`,
            component: SmsObserverList,
        },
        {
            path: `${pathPrefix}/sms-observers/create`,
            component: SmsObserverCreate,
        },
        {
            path: `${pathPrefix}/sms-observers/:id`,
            component: SmsObserverView,
        },
        {
            path: `${pathPrefix}/sms-observers/:id/edit`,
            component: SmsObserverEdit,
        },
        {
            path: `${pathPrefix}/translation-billings`,
            component: TranslationBillingList,
        },
        {
            path: `${pathPrefix}/translation-billings/:id`,
            component: TranslationBillingView,
        },
        {
            path: `${pathPrefix}/translation-billings/:id/edit`,
            component: TranslationBillingEdit,
        },
        {
            path: `${pathPrefix}/translation-drafts`,
            component: TranslationDraftList,
        },
        {
            path: `${pathPrefix}/translation-drafts/create`,
            component: TranslationDraftCreate,
        },
        {
            path: `${pathPrefix}/translation-drafts/:id`,
            component: TranslationDraftView,
        },
        {
            path: `${pathPrefix}/translation-drafts/:id/edit`,
            component: TranslationDraftEdit,
        },
        {
            path: `${pathPrefix}/translation-upload-batches`,
            component: TranslationUploadBatchList,
        },
        {
            path: `${pathPrefix}/translation-upload-batches/create`,
            component: TranslationUploadBatchCreate,
        },
        {
            path: `${pathPrefix}/translation-upload-batches/:id`,
            component: TranslationUploadBatchView,
        },
        {
            path: `${pathPrefix}/translation-upload-batches/:id/edit`,
            component: TranslationUploadBatchEdit,
        },
        {
            path: `${pathPrefix}/user-roles`,
            component: UserRoleList,
        },
        {
            path: `${pathPrefix}/user-roles/create`,
            component: UserRoleCreate,
        },
        {
            path: `${pathPrefix}/user-roles/:id`,
            component: UserRoleView,
        },
        {
            path: `${pathPrefix}/user-roles/:id/edit`,
            component: UserRoleEdit,
        },
        {
            path: `${pathPrefix}/validation-rules`,
            component: ValidationRuleList,
        },
        {
            path: `${pathPrefix}/validation-rules/create`,
            component: ValidationRuleCreate,
        },
        {
            path: `${pathPrefix}/validation-rules/:id`,
            component: ValidationRuleView,
        },
        {
            path: `${pathPrefix}/validation-rules/:id/edit`,
            component: ValidationRuleEdit,
        },
    ],
    scrollBehavior() {
        const element = document.getElementById("vue-app");
        if (Boolean(element)) {
            element.scrollIntoView();
        }
    },
});

router.beforeEach((to, from, next) => {
    setPreviousUrl(from.fullPath);
    next();
});

router.afterEach(() => {
    hideOpenDropdowns();
});

export default router;
